export default __webpack_public_path__ + "static/media/Me.51b1c1af.jpg";